import { React, PT, fetchApi } from '@gasbuddy/react';
import { Button, Modal, Header, Form, Icon, Popup, Message } from 'semantic-ui-react';

export class AddFeature extends React.Component {
  state = {
    analytics: true,
    assignments: false,
    ignorePoints: false,
  }

  onChange = (f, v) => { this.setState({ [f]: v }); }

  saveFeature = () => {
    this.setState({ loading: true, error: null }, async () => {
      const { fetch: fetchFn } = this.props;
      const { ignorePoints, name, internalName, analytics, assignments, cache } = this.state;
      const { status, body } = await fetchApi({
        url: '/system/features/edit/create',
        body: {
          name,
          internal_name: internalName,
          analytics,
          assignments,
          cache,
          ignore_points: ignorePoints,
        },
      });
      if (status !== 200) {
        this.setState({ loading: false, error: body });
      } else {
        this.setState({
          loading: false,
          opened: false,
          internalName: null,
          name: null,
        });
        fetchFn();
      }
    });
  }

  render() {
    const {
      opened, error, assignments, internalName, loading,
      ignorePoints, analytics, cache, name,
    } = this.state;

    return (
      <Modal
        open={opened}
        trigger={(
          <Button
            onClick={() => this.setState({ opened: true })}
            content="Add New Feature"
            color="green"
            icon="plus"
            labelPosition="left"
            floated="right"
          />
        )}
      >
        <Header content="Add a Feature" />
        <Modal.Content>
          {error
            && (
            <Message error>
              Unable to save feature:
              <pre>{JSON.stringify(error, null, '\t')}</pre>
            </Message>
            )
          }
          <p>
A
            <b>feature</b>
            {' '}
is a discrete piece of functionality in an application
          that you want to either roll out selectively or choose between variations
          of the feature. A feature contains &quot;variants&quot; which can be setup after
          the feature is created.
          </p>
          <p>
Example: The background color of the app, or whether to force
            registration before searching
          </p>
          <Form loading={loading}>
            <Form.Input
              label="Internal Name"
              name="internalName"
              value={internalName}
              onChange={(e, { value }) => this.onChange('internalName', value)}
              placeholder="short_and_unique_name"
            />
            <Form.Input
              label="Name"
              name="name"
              value={name}
              onChange={(e, { value }) => this.onChange('name', value)}
              placeholder="Human Readable Feature Name"
            />
            <Form.Checkbox
              label="Cache Values On Clients and Don't Send This Feature Unless It Has Changed"
              checked={cache}
              onChange={(e, { checked }) => this.setState({ cache: checked })}
            />
            <Form.Checkbox
              label="Log to Analytics"
              checked={analytics}
              onChange={(e, { checked }) => this.setState({ analytics: checked })}
            />
            <Form.Checkbox
              label="Ignore Points"
              checked={ignorePoints}
              onChange={(e, { checked }) => this.setState({ ignorePoints: checked })}
            />
            <Popup
              wide
              trigger={(
                <Form.Checkbox
                  label="Record Assignments"
                  checked={!!assignments}
                  onChange={(e, { checked }) => this.setState({ assignments: checked })}
                />
)}
              content={(
                <div>
                  <p>
Recorded assignments are significantly more intensive on our backend.
                  They randomly allocate visitors to variants (based on the variant rules
                  and point values), but
                    <b>persist</b>
                    {' '}
those values to the database for every
                  user as opposed to just performing a random numerical distribution across
                  the ids.
                  </p>
                  <p>
As a result, even if weights change, a user will continue to get
                  whatever variant they were originally given.
                  </p>
                </div>
)}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
Cancel
          </Button>
          <Button basic color="red" onClick={this.saveFeature}>
            <Icon name="plus" />
            {' '}
Add Feature
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

AddFeature.propTypes = {
  fetch: PT.func.isRequired,
};
